import React, { useEffect, useState } from "react";
import { Container, Row, Col, CardBody, Card, Input } from "reactstrap";
import { Link } from "react-router-dom";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import LovedBy from "./components/LovedBy";
import MyGymsVisited from "./components/MyGymsVisited";
import MyClubsGyms from "./components/MyClubsGyms";
import Saved from "./components/Saved";
import endpoints from "../../api/endpoints";
import { useSelector } from "react-redux";
import { get } from "../../api/axios";
import GymCheckList from "./components/GymCheckList";
import PlaceholderDashboard from "../../../src/assets/Group.svg";
const Dashboard = () => {
  document.title = " Gym Dashboard | Elevated Iron - Gym Dashboard";
  const { currentUser } = useSelector((state) => state.auth);
  const { userPermissions } = useSelector((state) => state.auth.currentUser);
  const [gymData, setGymData] = useState([]);
  const [seletedGymId, setSeletedGymId] = useState("");
  const gymIds = async () => {
    const resp = await get(
      `${endpoints.gym}/admin?userId=${currentUser.id}&limit=50`
    );
    if (resp?.data?.success) {
      setGymData(resp.data.data);

      setSeletedGymId(resp?.data?.data[0]?._id);
    }
  };

  useEffect(() => {
    gymIds();
  }, []);

  return (
    <React.Fragment>
      <div className="mx-2">
        {userPermissions?.gym?.["Create Gym"] ||
        userPermissions?.gym?.["Update Gym"] ? (
          <>
            <Row className="gx-2 justify-content-start">
              <Col xxl="6" xl="6" lg="6" md="6" sm="6" xs="12" className="mb-2">
                <div className="d-flex justify-content-center align-items-center">
                  <p className="m-0 fw-bold ff-sora font-size-20 text-nowrap me-3">
                    Gym Owner
                  </p>
                  <Input
                    id="exampleSelect"
                    name="select"
                    type="select"
                    style={{ borderRadius: 12, height: 46, border: "none" }}
                    className="fw-normal ff-sora font-size-14 border-none "
                    onChange={(e) => {
                      const selectedValue = e.target.value;
                      setSeletedGymId(selectedValue);
                    }}
                  >
                    {gymData.map((item, index) => (
                      <option key={index} value={item?._id}>
                        {item.name}
                      </option>
                    ))}
                  </Input>
                </div>
              </Col>
            </Row>
            <Row className="gx-2">
              <Col xxl="6" xl="6" lg="6" md="12" sm="12" xs="12">
                <MyGymsVisited seletedGymId={seletedGymId} />
              </Col>
              <Col xxl="6" xl="6" lg="6" md="12" sm="12" xs="12">
                <Saved seletedGymId={seletedGymId} />
              </Col>
              <Col xxl="6" xl="6" lg="6" md="12" sm="12" xs="12">
                <LovedBy seletedGymId={seletedGymId} />
              </Col>
              {seletedGymId != undefined && (
                <Col xxl="6" xl="6" lg="6" md="12" sm="12" xs="12">
                  <GymCheckList seletedGymId={seletedGymId} />
                </Col>
              )}
              {userPermissions?.gym?.["View Gym"] ? (
                <Col
                  xxl="12"
                  xl="12"
                  lg="12"
                  md="12"
                  sm="12"
                  xs="12"
                  className="mb-5"
                >
                  <MyClubsGyms />
                </Col>
              ) : (
                ""
              )}
            </Row>
          </>
        ) : (
          <Col xxl="12" xl="12" md="12" sm="12" xs="12">
            <Card
              className="rounded-4 ff-sora d-flex justify-content-center align-items-center text-center p-5 "
              style={{ height: "80vh" }}
            >
              <img
                src={PlaceholderDashboard}
                className="w-25"
                alt={`No Permission`}
              />
              <div className="w-50">
                <p className="ff-sora font-size-16 fw-medium mt-4">
                  Permission Required!
                </p>
                <p className="ff-sora font-size-16 fw-normal">
                  Your account doesn’t currently have full access to the
                  Dashboard. Contact your administrator to update your
                  permissions.
                </p>
              </div>
            </Card>
          </Col>
        )}
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
